export const BACK_TO_USERNAME = 'Back to username';
export const YOUR_PASSWORD = 'Your password';
